<template>
	<div v-if="!isLoadingWidgetFields">
		<div class="first_field mt-5" v-show="widgetFields.length < 1">
			<v-menu
				v-model="forceMenuOpen"
				origin="center bottom"
				transition="slide-y-transition"
				content-class="widget-selector-modal-menu"
				:close-on-content-click="false"
				:nudge-bottom="25"
			>
				<template v-slot:activator="{ on, attrs, value }">
					<div
						v-on="on"
						v-bind="attrs"
						@click="clearSidebarFocus"
						:class="{ selected: value }"
						class="add_field_btn flex-centerize flex-column"
					>
						<SIcon class="ic" :name="'add-field-new'" />
						<div>Click here to add a block</div>
					</div>
				</template>
				<WidgetSelectorModal
					:isOpen="forceMenuOpen"
					:selectedFieldType.sync="selectedFieldType"
					showConfigurationOnlyFields
					@addNewField="addNewField"
				/>
			</v-menu>
		</div>
		<div class="fields_part py-2" v-if="widgetFields.length >= 1" ref="fields_part">
			<Container
				group-name="1"
				@drop="onDrop($event)"
				v-if="widgetFields.length > 0"
				:drop-placeholder="dropPlaceholderOptions"
				:get-child-payload="getChildPayload"
				:tag="{ value: 'div', props: { class: 'row no-gutters' } }"
				non-drag-area-selector=".non-drag-area-class"
			>
				<BlockEditorWidgetLayoutDraggable
					editMode
					:field="field"
					:key="field.id"
					v-on="$listeners"
					:previousSteps="{}"
					@showMenu="showMenu"
					:testResponse="testResponse"
					v-for="field in localFields"
					:replaceInsertDataStringDict="replaceInsertDataStringDict"
					:configurationsMappingBlocksUUIDs="configurationsMappingBlocksUUIDs"
					:relativeToField="relativeToField"
					:isGeneralConfiguration="isGeneralConfiguration"
				/>
			</Container>
			<div ref="add_section_widget" class="add_section_widget flex-centerize" :class="{ 'selected-solid-border': menu }">
				<div @click="showMenu(localFields[localFields.length - 1], $event, 'bc', $refs.add_section_widget.getBoundingClientRect())">
					<v-btn height="30" width="30" style="background: #f5f8fe">
						<SIcon name="add-field-new" class="add-field-btn-content" />
					</v-btn>
				</div>
			</div>
			<v-menu v-model="menu" :position-x="x" :position-y="y" absolute offset-y content-class="men" :close-on-content-click="false">
				<WidgetSelectorModal :isOpen="menu" showConfigurationOnlyFields @addNewField="addNewField" />
			</v-menu>
		</div>
		<!-- <v-menu
			v-model="menu"
			:position-x="x"
			:position-y="y"
			absolute
			offset-y
			content-class="men widget-selector-modal-menu"
			:close-on-content-click="false"
		>
			<WidgetSelectorModal :isOpen="menu" showConfigurationOnlyFields @addNewField="addNewField" />
		</v-menu> -->
		<!-- This appears to be rendered always. should be deleted down the road -->
	</div>
	<Loader v-else />
</template>

<script>
import { Container } from 'vue-smooth-dnd';
import { mapGetters, mapActions } from 'vuex';

import BlockEditorWidgetLayoutDraggable from '@/components/BlockEditorWidget/BlockEditorWidgetLayoutDraggable.vue';
import WidgetSelectorModal from '@/components/BlockEditorWidget/WidgetSelectorModal/WidgetSelectorModal.vue';
import { setWidgetTitle } from '@/store/modules/widgetEditor/actions';

export default {
	name: 'EditConfigurationInterface',
	props: {
		testResponse: { type: Object },
		replaceInsertDataStringDict: { type: Object }, //maybe not in use
		configurationsMappingBlocksUUIDs: { type: Array }, //maybe not in use
		isGeneralConfiguration: { type: Boolean },
	},
	components: {
		Container,
		WidgetSelectorModal,
		BlockEditorWidgetLayoutDraggable,
	},
	computed: {
		...mapGetters('selectedNode', ['editNode']),
		...mapGetters('widgetEditor', ['widgetFields', 'editField', 'widgetMetadata', 'widgetTitle', 'isLoadingWidgetFields']),
	},
	watch: {
		selectedFieldType(n, o) {
			if (n !== o && n) {
				this.updateFieldType(this.selectedFieldType);
			}
		},
		widgetFields: {
			handler(n) {
				if (n) {
					this.localFields = n;
				}
			},
			immediate: true,
		},
		menu(newVal) {
			if (!newVal) {
				this.relativeToField = null;
			}
		},
	},
	methods: {
		...mapActions([setWidgetTitle.fullPath]),
		...mapActions('widgetEditor', ['addField', 'updateFieldsOrder', 'setWidgetOption']),
		clearSidebarFocus() {
			this.$emit('clear-sidebar-focus');
		},
		addNewBlock() {
			// This function is triggered from parent
			if (this.widgetFields?.length < 1) {
				this.forceMenuOpen = true;
			} else {
				this.scrollToFormBottom();
				this.showMenu(this.localFields[this.localFields.length - 1], null, 'bc', this.$refs.add_section_widget.getBoundingClientRect());
			}
		},
		scrollToFormBottom() {
			setTimeout(() => {
				const formBottom = this.$refs.fields_part;
				formBottom.scrollTop = formBottom.scrollHeight;
			}, 400);
		},
		addNewField(field) {
			this.menu = false;
			this.forceMenuOpen = false;
			const fieldIndex = this.localFields.findIndex((f) => f.id === this.relativeToField.id);
			const ind = this.addPos == 'tc' ? fieldIndex : fieldIndex + 1;
			const o = {
				payload: field,
				addedIndex: ind,
				removedIndex: null,
			};
			this.addField(o);
			this.scrollToFormBottom();
		},
		showMenu(field, e, addPos, fieldRect) {
			this.addPos = addPos;
			this.relativeToField = field;
			e?.preventDefault();
			const menuWidth = window
				.getComputedStyle(document.documentElement)
				.getPropertyValue('--widget-selector-modal-width')
				.replace('px', ''); //Strip px off
			this.x = fieldRect.left + fieldRect.width / 2 - menuWidth / 2;
			this.y = fieldRect.top;
			if (this.addPos !== 'tc') {
				this.y += fieldRect.height;
			}
			this.$nextTick(() => {
				this.menu = true;
			});
		},
		getChildPayload(index) {
			return this.widgetFields[index];
		},
		onDrop(dropResult) {
			const { payload, removedIndex, addedIndex } = dropResult;
			if (removedIndex === null && addedIndex === null) return;
			if (payload && payload.temp) {
				this.addField(dropResult);
			} else {
				this.updateFieldsOrder(dropResult);
			}
		},
	},
	data: () => ({
		showAddBtns: true,
		localFields: null,
		fieldIndex: null,
		menu: false,
		x: 0,
		y: 0,
		addPos: null,
		fieldMenu: {},
		testMode: false,
		selectedFieldType: '',
		dropPlaceholderOptions: {
			className: 'drop-preview',
			showOnTop: true,
		},
		relativeToField: null,
		forceMenuOpen: false,
	}),
};
</script>

<style scoped lang="scss">
$side-padding: 20px;

.add_section_widget {
	// It has to be underscore because of the ref
	height: 35px;
	margin: 15px 19px;
	border-radius: 6px;
	background: #f5f8fe;

	&:hover {
		border: 1px dashed var(--primary-color);
	}
}

.selected-solid-border {
	border: 1px solid var(--primary-color);
}

.first_field {
	height: 70px;
	background: #f5f8fe;
	border-radius: 6px;
	box-shadow: none !important;
	position: relative;
	margin: 0px $side-padding;

	.v-menu {
		display: block;
	}
}

.add_field_btn {
	position: absolute;
	top: 50%;
	left: 50%;
	opacity: 1;
	margin-top: -1px;
	z-index: 2;
	visibility: visible;
	transform: translate(-50%, -50%);
	color: var(--primary-color);
	font-size: 14px;
	width: 100%;
	height: 100%;
	border-radius: 6px;
	&:hover {
		border: 1px dashed var(--primary-color);
	}
	&.selected {
		border: 1px solid var(--primary-color);
	}
}

.fields_part {
	position: relative;
	$fields-part-max-height: 50vh;
	max-height: $fields-part-max-height;
	overflow-y: auto;
}
.add-field-btn-content {
	cursor: pointer;
	width: 19px;
	height: 19px;
	border-radius: 50%;
	box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
}
</style>
